import { defineComponent as _defineComponent } from 'vue'
import {
  PropType,
  computed,
  onMounted,
  onUnmounted,
  ref,
} from 'vue';

import {
  useI18n
} from '@/composables/useI18n';
import {ErrorItemResult, OperationResults} from "@/scripts/Common";
import {FileDownload} from "@/scripts/Common/FileDownload";
import {TXT_EXTENSION} from "@/scripts/Constants";



export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorItemDialog',
  props: {
  response: {
    required: false,
    type: Object as PropType<OperationResults<any>>,
  },
},
  emits: [
  'onDialogCancelOrConfirm',
],
  setup(__props, { emit: emits }) {

const props = __props;





const {
  t,
  te
} = useI18n();

const isDialogVisible = ref<boolean>(false);

const hasSuccessfulItems = computed(() => props.response?.successfulItems.length > 0)
const hasFailedItems = computed(() => props.response?.failedItems.length > 0)

const successfulElements = computed(() => {
  const elements = props.response?.successfulItems.join(', ');
  return `${t('successful_items')}: ${elements}`
})

const failedElements = computed(() => {
  const elements = props.response.failedItems.map((element: any) => element.id).join(', ');
  return `${t('failed_items')}: ${elements}`
})

const formatErrorItemResult = (item: ErrorItemResult): string[] => item.errorCodes
  .map(element => te(`errorCodes.${element}`) ? t(`errorCodes.${element}`) : element);

const translatedErrorMessages = computed(() => {
  return props.response?.failedItems.map((element: ErrorItemResult) => ({ item: element.id, errors: formatErrorItemResult(element)}))
})

const generateTranslatedErrorString = () => {
  try{
    //replace bracked, quotes commas and empty lines.
    return JSON.stringify(translatedErrorMessages.value, undefined, 2)
      .replace(/[\[\]{}",']+/g, '')
      .replace(/^\s*\n/gm, '');
  }
  catch (e) {
    return `${t('server_error')}, ${t('try_again_later')}`;
  }
}

const generateTextFile = () => {
  const textFile = new Blob([generateTranslatedErrorString()], { type: "text/plain;charset=utf-8" });

  FileDownload.Create(textFile, `${t('error_filename')}.${TXT_EXTENSION}`);
}

const onHandleDialogAction = () => {
  isDialogVisible.value = false;
  emits('onDialogCancelOrConfirm');
}

onMounted(() => {
  isDialogVisible.value = true;
})

onUnmounted(() => {
  isDialogVisible.value = false;
})

return { __sfc: true,props, emits, t, te, isDialogVisible, hasSuccessfulItems, hasFailedItems, successfulElements, failedElements, formatErrorItemResult, translatedErrorMessages, generateTranslatedErrorString, generateTextFile, onHandleDialogAction }
}

})